module.exports = __webpack_public_path__ + "img/9788952215604.0436d0c4.jpg";